<template>
  <router-view></router-view>
</template>

<script>
export default {

  created: function() {
    let self = this;
    this.$http.interceptors.response.use(
      response => {
        return response;
      },
      function(error) {
        // Do something with response error
        if (error.response.status === 401) {
          console.log("unauthorized, logging out ...");
          console.log("current ", self.$router.currentRoute);

          self.$store
            .dispatch("logout")
            .then(() => {
              console.log("go logout");
              // 接收 resolve
              setTimeout(() => {
                // 使用 $router.push 轉跳到 hello Page
                if (
                  self.$router.currentRoute &&
                  (
                    self.$router.currentRoute.path === "/si-login" ||
                    self.$router.currentRoute.path === "/gaa-login" ||
                    self.$router.currentRoute.path === "/qcpos/login"
                  )
                ) {
                  
                } else {
                  switch (self.$store.state.lastPortalType) {
                    case 'gaa':
                      self.$router.push("/gaa-login");
                      break;
                    case 'si':
                      self.$router.push("/si-login");
                      break;
                    case 'eaa':
                      self.$router.push("/eaa-login");
                      break;
                    default:
                      self.$router.push("/eaa-login");
                      break;
                  }
                  
                }
              }, 1000);
            })
            .catch(e => {
              // 接收 reject
              console.log("error get Promise reject!" + e.stack);
            });
          // auth.logout();
          // router.replace('/auth/login');
        }
        return Promise.reject(error.response);
      }
    );

    // this.$http.interceptors.response.use(undefined, function (err) {
    //   return new Promise(function (resolve, reject) {
    //     console.log('any injection?? ', err);
    //     if (err.status === 401) {
    //     // if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
    //       this.$store.dispatch(logout)
    //     }
    //     throw err;
    //   });
    // });
  },


  mounted() {
    // this.initCheatDetector();
  },

  methods: {
    // initCheatDetector() {
    //   document.addEventListener('keypress', evt => {
    //     if (this.keyBuf == this.keyComb) return;
    //     // console.log(`Key press`, String.fromCharCode(evt.keyCode));

    //     let keyCode = evt.keyCode;
    //     let nextCheatCode = this.keyComb.charCodeAt(this.keyBuf.length);
    //     if (keyCode === nextCheatCode) {
    //       this.keyBuf += this.keyComb.charAt(this.keyBuf.length);
    //       if (this.keyBuf === this.keyComb) {
    //         //TODO: Fire cheat-confirmed event.
    //         // console.warn(`Cheat enabled`, this.keyBuf);
    //         this.$store.commit('enableCheat');
    //       }
    //     }
    //     else {
    //       if (keyCode === this.keyComb.charCodeAt(0))
    //         this.keyBuf = this.keyComb.charAt(0);
    //       // console.log('Key buffer reset', this.keyBuf);
    //     }
    //   }, false);
    // }
  },

  data() {
    return {
      keyBuf: '',
      keyComb: 'showmemore'
    };
  }
};
</script>
